import { Typography } from "@mui/material";
import i18n from "i18next";

export const TestEnvironmentWarningText = () => {
	return (
		<Typography
			color={"error"}
			variant={"h5"}
			sx={{
				flex: 1,
				textAlign: "center",
			}}
		>
			{i18n.t("not_production_environment_warning").toUpperCase()}
		</Typography>
	);
};
